import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OpenPageModel, OpenPageService } from '../../services/open-page.service';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.css'],
    standalone: false
})
export class TermsComponent implements OnInit {
  openPage: OpenPageModel;

  lang: string;

  @Input()
  empSpecificContents: any;

  constructor(public translate: TranslateService, public openPageService: OpenPageService) {}

  ngOnInit() {
    this.openPageService.currentOpenPage.subscribe(openPage => (this.openPage = openPage));
  }

  closeTerms(): void {
    this.openPage.termsOpen = false;
    this.openPage.selectedPageOpen = false;
    this.openPageService.changeOpenPage(this.openPage);
  }
}
